import DatePicker from 'react-datepicker';
import './filter-bar.scss';
import { useTranslation } from 'react-i18next';
import DropdownWithFilter from '../../../elements/dropdown-with-filter/dropdown-with-filter';
import { AccountingNumberDto } from '../../../../models/accounting-number.dto';
import { CostCenterDto } from '../../../../models/cost-center.dto';
import { Button } from 'react-bootstrap';
import { notEmptyArray } from '../../../../utils/base';

interface PropsType {
   onChangeFilterBar;
   fromDate: Date;
   toDate: Date;
   fromAmount: string;
   toAmount: string;
   costCenterValue: string;
   accountingNumberValue: string;
   accountingNumbers: AccountingNumberDto[];
   costCenters: CostCenterDto[];
   resetFilterValues: () => void;
   onClose: () => void;
}

const FilterBar = ({
   onChangeFilterBar,
   fromDate,
   toDate,
   fromAmount,
   toAmount,
   costCenterValue,
   accountingNumberValue,
   accountingNumbers,
   costCenters,
   resetFilterValues,
   onClose,
}: PropsType) => {
   const [translate] = useTranslation(['account', 'common', 'invoice']);

   const costCentersExist = notEmptyArray(costCenters);

   const accountingNumbersWithNone = [
      { accountingNumber: 'NONE', name: 'NONE' },
      ...accountingNumbers
   ];

   return (
      <div id='invoice-filter-panel' className='invoice-filter-panel' >
         <div className='filter-fields'>
            <div id='dateRangeHeader' className='filter-field'>
               <span className='label'>{translate('common:search.dateRange')}</span>
               <div className='filter-range-row'>
                  <div className='range-control'>
                     <DatePicker
                        selected={fromDate}
                        dateFormat='dd/MM/yyyy'
                        onChange={(date: Date) => {
                           onChangeFilterBar(
                              date,
                              toDate,
                              fromAmount,
                              toAmount,
                              accountingNumberValue,
                              costCenterValue,
                           );
                        }}
                        className='input'
                     />
                  </div>
                  <span className='range-separator'>{translate('common:search.to')}</span>
                  <div className='range-control'>
                     <DatePicker
                        selected={toDate}
                        dateFormat='dd/MM/yyyy'
                        onChange={(date: Date) => {
                           onChangeFilterBar(
                              fromDate,
                              date,
                              fromAmount,
                              toAmount,
                              accountingNumberValue,
                              costCenterValue,
                           );
                        }}
                        className='input'
                     />
                  </div>
               </div>
            </div>

            <div id='amountRangeHeader' className='filter-field'>
               <span className='label'>{translate('common:search.amountRange')}</span>
               <div className='filter-range-row'>
                  <div className='range-control'>
                     <input
                        type='number'
                        value={fromAmount}
                        onChange={(e) => {
                           onChangeFilterBar(
                              fromDate,
                              toDate,
                              e.target.value,
                              toAmount,
                              accountingNumberValue,
                              costCenterValue,
                           );
                        }}
                        className='input'
                     ></input>
                  </div>
                  <span className='range-separator'>{translate('common:search.to')}</span>
                  <div className='range-control'>
                     <input
                        type='number'
                        value={toAmount}
                        onChange={(e) => {
                           onChangeFilterBar(
                              fromDate,
                              toDate,
                              fromAmount,
                              e.target.value,
                              accountingNumberValue,
                              costCenterValue,
                           );
                        }}
                        className='input'
                     ></input>
                  </div>
               </div>
            </div>

            <div className='select'>
               <span className='label' >{translate('invoice:invoice.accountingNumber')}:</span>
               <div className='select-control'>
                  <DropdownWithFilter
                     className='drop-down-select'
                     colorMode='dark'
                     items={accountingNumbersWithNone}
                     selectedValue={accountingNumberValue}
                     tooltip={accountingNumberValue ? translate(accountingNumberValue) ?? '' : ''}
                     getMenuItemValue={(accountingNumber: AccountingNumberDto) =>
                        `${accountingNumber.accountingNumber} - ${accountingNumber.name}`
                     }
                     handleChange={(item: AccountingNumberDto) => {
                        onChangeFilterBar(
                           fromDate,
                           toDate,
                           fromAmount,
                           toAmount,
                           item.accountingNumber,
                           costCenterValue,
                        );
                     }}
                     handleFilter={(accountNumbers, filterValue) =>
                        accountNumbers.filter(
                           (accountNumber: AccountingNumberDto) =>
                              accountNumber.accountingNumber
                                 .toLowerCase()
                                 .includes(filterValue.toLowerCase()) ||
                              accountNumber.name.toLowerCase().includes(filterValue.toLowerCase()),
                        )
                     }
                  ></DropdownWithFilter>
               </div>
            </div>

            {costCentersExist &&
               <div className="select">
                  <span className="label">{translate('invoice:invoice.costCenter')}:</span>
                  <div className="select-control">
                     <DropdownWithFilter
                        className="drop-down-select"
                        colorMode="dark"
                        items={costCenters}
                        selectedValue={costCenterValue}
                        tooltip={costCenterValue ? translate(costCenterValue) ?? '' : ''}
                        getMenuItemValue={(costCenter: CostCenterDto) =>
                           `${costCenter.costCenter} - ${translate(costCenter.name)}`
                        }
                        handleChange={(item: CostCenterDto) => {
                           onChangeFilterBar(
                              fromDate,
                              toDate,
                              fromAmount,
                              toAmount,
                              accountingNumberValue,
                              item.costCenter,
                           );
                        }}
                        handleFilter={(costCenters, filterValue) =>
                           costCenters.filter(
                              (costCenter: CostCenterDto) =>
                                 costCenter.costCenter
                                    .toLowerCase()
                                    .includes(filterValue.toLowerCase()) ||
                                 costCenter.name.toLowerCase().includes(filterValue.toLowerCase()),
                           )
                        }
                     ></DropdownWithFilter>
                  </div>
               </div>
            }
         </div>

         <div className='filter-actions'>
            <Button className='clear-btn' onClick={() => resetFilterValues()}>
               {translate('common:search.clearAllFilters')}
            </Button>
            <div>
               <Button className='outline-primary' onClick={onClose}>{translate('common:common.close')}</Button>
               <Button className='primary' onClick={onClose}>Apply</Button>
            </div>
         </div>
      </div>
   );
};

export default FilterBar;
